<template>
    <div class="state">
        <p>原创声明，本文系作者授权发表，未经许可，不得转载。</p>
        <p>如有侵权，请联系管理员删除。</p>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.state {
    margin-top: 31px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
}
</style>
